import { render, staticRenderFns } from "./WaitingAdoption.vue?vue&type=template&id=e57c29ca&"
import script from "./WaitingAdoption.vue?vue&type=script&lang=js&"
export * from "./WaitingAdoption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports